import { Pipe, PipeTransform } from '@angular/core';
import { DataService } from '../services/data.service';

@Pipe({
    name: 'priceSeparator',
    pure: true,
    standalone: false
})
export class PriceSeparatorPipe implements PipeTransform {
  constructor(private dataService: DataService) {}

  private get decimal(): boolean | undefined {
    return this.dataService.locale?.decimal;
  }
  
  transform(price: number, decimal: boolean = false): { whole: string; fraction: string; separator: string } {
    if (price == null) return { whole: '', fraction: '', separator: '.' };

    const locale = document.documentElement.lang;
    const separator = this.getDecimalSeparator(locale);

    const formatted = price.toLocaleString(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  
    const sepIndex = formatted.lastIndexOf(separator);
    const whole = sepIndex !== -1 ? formatted.slice(0, sepIndex) : formatted;
    const fraction = sepIndex !== -1 ? formatted.slice(sepIndex + 1) : '00';

    if (this.decimal === false && decimal === false) return { whole, fraction: '', separator: '' };
    
    // console.log('PriceSeparatorPipe | transform() | price:', price, '| formatted:', formatted, '| whole:', whole, '| fraction:', fraction, '| separator:', separator);
    
    return { whole, fraction, separator };
  }

  private getDecimalSeparator(locale: string): string {
    const numberWithDecimal = 1.1;
    return numberWithDecimal.toLocaleString(locale).replace(/\d/g, '')[0] || '.';
  }
}